<div class="page-title animatedBackground">
    <div class="container">
        <h3>Point of Sale (POS)</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li><a routerLink="/our-solutions">Our Solutions</a></li>
            <li class="dot-divider"></li>
            <li>Point of Sale (POS)</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div class="services-details-desc">
                <h3>Sharpen your Focus on Customer Service with POS</h3>
                <p>A fully-featured, mobile-enabled POS solution that can be deployed on any type of device to deliver excellent customer service everywhere in the store.</p>
              
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Adopt a modern and fully-featured POS solution that can run on any device using just a web browser</h4>
                    <h4><i class="icofont-check-alt"></i> Empower your associates identical POS functionality available on any type of device</h4>
                    <h4><i class="icofont-check-alt"></i> Gain the freedom to select the devices of your choice thanks to a responsive user interface and minimum technical requirements supported by a wide range of physical devices</h4>
                    <h4><i class="icofont-check-alt"></i> Ensure uninterrupted sales with Openbravo's offline-resistant technology</h4>
         

                </div>
            </div>

            <div class="services-details-image">
                <img src="assets/img/pos.png" alt="image">
            </div>
        </div>

        <div class="services-details-overview">
            <div class="services-details-image">
                <img src="assets/img/pos2.png" alt="image">
            </div>

            <div class="services-details-desc">
                <h3>Key Features</h3>
                <div class="features-text">
                    <h4><i class="icofont-check-alt"></i> Multi Store POS Management</h4>
                    <h4><i class="icofont-check-alt"></i> Online & Offline Sales</h4>
                    <h4><i class="icofont-check-alt"></i> Order Management</h4>
                    <h4><i class="icofont-check-alt"></i> Customer Management</h4>
                    <h4><i class="icofont-check-alt"></i> Offers & Promotions</h4>
                    <h4><i class="icofont-check-alt"></i> Payment </h4>
                    <h4><i class="icofont-check-alt"></i> Cash up</h4>
                    <h4><i class="icofont-check-alt"></i> Product & Inventory Management</h4>
                </div>
              
            </div>
        </div>
    </div>
</section>